// Used to remove falsy values and ensure typing is right on an equivalent definition
export function notFalsy<TValue>(value: TValue | null | undefined): value is TValue {
    return !!value;
}
